import LoadingSpinner from "components/layout/loading-spinner"
import Overlay from "components/layout/overlay"

const state = {count: 0}
const eventEmitter = new EventEmitter()

const increaseLoading = (loadingId, label) => {
  state.count += 1
  eventEmitter.emit("loadingIncreased", loadingId, label)
}

const decreaseLoading = (loadingId) => {
  state.count -= 1
  eventEmitter.emit("loadingDecreased", loadingId)
}

const loading = async (label, callback) => {
  const loadingId = uuidv4()

  try {
    increaseLoading(loadingId, label)

    return await callback()
  } finally {
    decreaseLoading(loadingId)
  }
}

const LoadingBlocker = () => {
  const s = useShape()

  s.useStates({loadings: {}})

  const onLoadingDecreased = useCallback((loadingId) => {
    const newLoadings = Object.assign({}, s.s.loadings)

    delete newLoadings[loadingId]

    s.set({loadings: newLoadings})
  }, [])

  const onLoadingIncreased = useCallback((loadingId, label) => {
    const newLoadings = Object.assign({}, s.s.loadings)

    newLoadings[loadingId] = {id: loadingId, label}

    s.set({loadings: newLoadings})
  }, [])

  const count = Object.keys(s.s.loadings).length

  useEventEmitter(eventEmitter, "loadingDecreased", onLoadingDecreased)
  useEventEmitter(eventEmitter, "loadingIncreased", onLoadingIncreased)

  return (
    <>
      {count > 0 &&
        <Overlay className="components--layout--loading-blocker" style={{zIndex: 1000}}>
          <div style={{display: "flex", alignItems: "center"}}>
            <div style={{marginRight: "25px"}}>
              <LoadingSpinner />
            </div>
            <div>
              {Object.values(s.s.loadings).map((loading) =>
                <div key={loading.id}>
                  <div>{loading.label}</div>
                </div>
              )}
            </div>
          </div>
        </Overlay>
      }
    </>
  )
}

export {decreaseLoading, increaseLoading, loading, LoadingBlocker}
